import { render, staticRenderFns } from "./VehicleEntityDetails.vue?vue&type=template&id=de99187a&"
import script from "./VehicleEntityDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de99187a')) {
      api.createRecord('de99187a', component.options)
    } else {
      api.reload('de99187a', component.options)
    }
    module.hot.accept("./VehicleEntityDetails.vue?vue&type=template&id=de99187a&", function () {
      api.rerender('de99187a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VehicleEntityDetails.vue"
export default component.exports